// Only define the custom element if it hasn't been defined before
if (!customElements.get('show-more-button')) {
  // Define a new custom element called 'show-more-button'
  customElements.define('show-more-button',class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        // Find the button element within this custom element
        const button = this.querySelector('button');

        // Add click event listener to the button
        button.addEventListener('click', (event) => {
          // Handle expanding/collapsing content
          this.expandShowMore(event);

          // Find the next element to focus after expansion
          // Looks for the first show-more-item within the parent display
          const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item');

          // If we found an element to focus and it's visible (not hidden)
          // and contains an input, focus on that input
          if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden') && nextElementToFocus.querySelector('input')) {
            nextElementToFocus.querySelector('input').focus();
          }
        });
      }

      // Method to handle expanding/collapsing the show more content
      expandShowMore(event) {
        // Find the parent container elements
        const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
        const parentWrap = parentDisplay.querySelector('.parent-wrap');

        // Toggle visibility of all label text elements
        this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));

        // Toggle visibility of all show-more-items
        parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));

        // If there's no "show less" label, hide the button completely
        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }
      }
    }
  );
}
